<template>
	<div class="container-fluid">
		<div class="container-fluid bg-base-green trees-bg">
      <div class="row pt-5 pb-5">
        <div class="col-12">
          <h1 class="title text-center">{{$t('contacto_titulo')}}</h1>          
        </div>      
      </div>
    </div>
		<div class="container pt-5 pb-5">
			<div class="row justify-content-center mt-5 mb-5">
				<div class="col-7 text-center">
					<p class="mt-3 plataforma-parrafo">
						{{$t('contacto_parrafo')}}						
					</p>
					<div>{{$t('contacto_mail')}}</div>

				</div>
				
			</div>

		</div>

	</div>
</template>

<script>


export default {
	name: 'Contacto'	
}
</script>
